export default {
  apiHost: 'https://api.dev.getesf.com/v1',
  fakeFetchDelay: 1000,
}
